import {AfterViewInit, Component, Input} from '@angular/core';
import {environment} from '../environments/environment';
import {FirebaseService} from '../app/firebase.service';

// see https://github.com/paypal/paypal-checkout/issues/368

// TODO buttons werden mehrfach erzeugt

// import global paypal script from index.html
declare let paypal: any;

@Component({
  selector: 'app-paypal-button',
  template: '<div [id]="id"></div>',
  styles: []
})
export class PaypalButtonComponent implements AfterViewInit {
  readonly id = 'paypal-button';
  @Input()
  betrag: number;
  private viewIsInitialized = false;

  readonly style = {
    label: 'pay',
    size: 'small', // small | medium | large | responsive (responsive might lead to two buttons with different size)
    shape: 'rect', // pill | rect
    color: 'gold',  // gold | blue | silver | black,
    tagline: false
  };

  constructor(private firebaseService: FirebaseService) { }

  ngAfterViewInit() {
    this.viewIsInitialized = true;
    this.render();
  }

  private render() {
    if (!this.viewIsInitialized) {
      return;
    }
    this.clear();
    if (!this.betrag) {
      return;
    }
    // console.log('render', this.betrag);
    paypal.Button.render({
      env: environment.paypalEnv,
      style: this.style,
      commit: true,
      payment: () => this.payment(),
      onAuthorize: (data, actions) => this.onAuthorize(data, actions)
    }, `#${this.id}`);
  }

  private payment() {
    return new paypal.Promise((resolve, reject) => {
      const body = {
        betrag: this.betrag,
      };
      this.firebaseService.postToCloudFunction('paypalCreate', body)
        .then(data => {
          // console.log('paypalCreate done: data.paymentID:', data.paymentID);
          resolve(data.paymentID);
        });
    });
  }

  private onAuthorize(data, actions) {
    // console.log('paypal.Button.onAuthorize()', data);
    return new paypal.Promise((resolve, reject) => {
      const body = {
        paymentID: data.paymentID,
        payerID: data.payerID
      };
      this.firebaseService.postToCloudFunction('paypalExecute', body)
        .then(() => {
          // console.log('paypalExecute done');
          resolve();
        });
    });
  }

  private clear() {
    const element = document.getElementById(this.id);
    while (element.firstChild) {
      element.removeChild(element.firstChild);
    }
  }
}
